import * as Option from "fp-ts/lib/Option";
var registrations = {};
export function register(id, datetime, callback) {
    var registrationIds = Object.keys(registrations);
    if (registrationIds.includes(id)) {
        return Option.some("DUPLICATE_ID");
    }
    var nowMs = Date.now();
    var deadlineMs = Date.parse(datetime);
    if (Number.isNaN(deadlineMs)) {
        return Option.some("INVALID_DATE");
    }
    if (nowMs >= deadlineMs) {
        return Option.some("DATE_EXPIRED");
    }
    var durationMs = deadlineMs - nowMs;
    var timeoutId = setTimeout(callback, durationMs);
    registrations[id] = timeoutId;
    return Option.none;
}
export function unregister(id) {
    var registrationIds = Object.keys(registrations);
    if (!registrationIds.includes(id)) {
        return Option.some("ID_NOT_FOUND");
    }
    var timeoutId = registrations[id];
    clearTimeout(timeoutId);
    delete registrations[id];
    return Option.none;
}
